import { render, staticRenderFns } from "./EditComunity.vue?vue&type=template&id=34afc38c&"
import script from "./EditComunity.vue?vue&type=script&lang=js&"
export * from "./EditComunity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports